export default __webpack_public_path__ + "v1.18.25/static/media/libreLinkUp.07cb949d.svg";